<template>
  <div v-if="hasError" class="min-h-[400px] flex items-center justify-center p-6">
    <div class="text-center max-w-md">
      <div class="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <IconTriangleAlert class="w-8 h-8 text-red-500" />
      </div>
      <h3 class="text-lg font-bold text-slate-900 mb-2">
        页面加载出错
      </h3>
      <p class="text-sm text-slate-500 mb-6">
        抱歉，页面加载时遇到了问题。请尝试刷新页面。
      </p>
      <button
        @click="handleRetry"
        class="inline-flex items-center gap-2 px-4 py-2 bg-amber-400 text-white rounded-lg hover:bg-amber-500 transition-colors"
      >
        <IconRefreshCw class="w-4 h-4" />
        重新加载
      </button>
    </div>
  </div>
  <div v-else>
    <slot />
  </div>
</template>

<script>
import { IconTriangleAlert, IconRefreshCw } from '../icons'

export default {
  name: 'ErrorBoundary',
  components: {
    IconTriangleAlert,
    IconRefreshCw
  },
  data() {
    return {
      hasError: false,
      error: null
    }
  },
  errorCaptured(err) {
    console.error('Error caught by boundary:', err)
    this.hasError = true
    this.error = err
    return false
  },
  methods: {
    handleRetry() {
      this.hasError = false
      this.error = null
    }
  }
}
</script>
